import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, mergeMap, tap } from 'rxjs/operators';
import { AclRouterStoreSelectors } from '../router';
import { UserGroupStoreActions, UserGroupStoreSelectors } from '../user-group';

@Injectable({ providedIn: 'root' })
export class UserGroupResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(AclRouterStoreSelectors.selectCurrentAclId).pipe(
      mergeMap((x) =>
        this.store.select(UserGroupStoreSelectors.selectGroupByParentId(x ?? '')).pipe(
          tap((y) => {
            if (y.length < 1) {
              this.store.dispatch(
                UserGroupStoreActions.UserGroupResolverActions.userGroupsRequested({ userId: x ?? '' })
              );
            }
          })
        )
      ),
      map(() => true),
      first()
    );
  }
}
